export const StatuspageMarkNeutral = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0001 38.3632C29.0441 38.3632 33.1331 34.2742 33.1331 29.2302C33.1331 24.1862 29.0441 20.0972 24.0001 20.0972C18.956 20.0972 14.8671 24.1862 14.8671 29.2302C14.8671 34.2742 18.956 38.3632 24.0001 38.3632Z"
      fill="url(#paint0_linear_818_507)"
    />
    <path
      d="M4.74404 18.667L9.64704 24.475C10.024 24.921 10.697 24.977 11.132 24.587C19.072 17.469 28.928 17.469 36.867 24.587C37.302 24.977 37.975 24.921 38.352 24.475L43.255 18.667C43.626 18.227 43.567 17.575 43.134 17.196C31.614 7.11697 16.385 7.11697 4.86504 17.196C4.43204 17.575 4.37304 18.227 4.74404 18.667Z"
      fill="#77859B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_507"
        x1="24.0001"
        y1="35.2202"
        x2="24.0001"
        y2="19.0412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#77859B" />
        <stop offset="0.824" stopColor="#304566" />
      </linearGradient>
    </defs>
  </svg>
);
